import { render, staticRenderFns } from "./store-search.vue?vue&type=template&id=5204c0a6&scoped=true"
import script from "./store-search.vue?vue&type=script&lang=js"
export * from "./store-search.vue?vue&type=script&lang=js"
import style0 from "./store-search.vue?vue&type=style&index=0&id=5204c0a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5204c0a6",
  null
  
)

export default component.exports